module.exports = __webpack_public_path__ + "static/media/calendar_1.d71b3d7e.svg";